import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Command } from 'ckeditor5/src/core.js';
import { getSelectionAffectedTable } from '../../utils/common.js';
/**
 * The table cell attribute command.
 *
 * This command is a base command for other table property commands.
 */
var TablePropertyCommand = /*#__PURE__*/function (_Command) {
  _inherits(TablePropertyCommand, _Command);
  var _super = _createSuper(TablePropertyCommand);
  /**
   * Creates a new `TablePropertyCommand` instance.
   *
   * @param editor An editor in which this command will be used.
   * @param attributeName Table cell attribute name.
   * @param defaultValue The default value of the attribute.
   */
  function TablePropertyCommand(editor, attributeName, defaultValue) {
    var _this;
    _classCallCheck(this, TablePropertyCommand);
    _this = _super.call(this, editor);
    _this.attributeName = attributeName;
    _this._defaultValue = defaultValue;
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(TablePropertyCommand, [{
    key: "refresh",
    value: function refresh() {
      var editor = this.editor;
      var selection = editor.model.document.selection;
      var table = getSelectionAffectedTable(selection);
      this.isEnabled = !!table;
      this.value = this._getValue(table);
    }
    /**
     * Executes the command.
     *
     * @fires execute
     * @param options.value If set, the command will set the attribute on the selected table.
     * If not set, the command will remove the attribute from the selected table.
     * @param options.batch Pass the model batch instance to the command to aggregate changes,
     * for example, to allow a single undo step for multiple executions.
     */
  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var selection = model.document.selection;
      var value = options.value,
        batch = options.batch;
      var table = getSelectionAffectedTable(selection);
      var valueToSet = this._getValueToSet(value);
      model.enqueueChange(batch, function (writer) {
        if (valueToSet) {
          writer.setAttribute(_this2.attributeName, valueToSet, table);
        } else {
          writer.removeAttribute(_this2.attributeName, table);
        }
      });
    }
    /**
     * Returns the attribute value for a table.
     */
  }, {
    key: "_getValue",
    value: function _getValue(table) {
      if (!table) {
        return;
      }
      var value = table.getAttribute(this.attributeName);
      if (value === this._defaultValue) {
        return;
      }
      return value;
    }
    /**
     * Returns the proper model value. It can be used to add a default unit to numeric values.
     */
  }, {
    key: "_getValueToSet",
    value: function _getValueToSet(value) {
      if (value === this._defaultValue) {
        return;
      }
      return value;
    }
  }]);
  return TablePropertyCommand;
}(Command);
export { TablePropertyCommand as default };